import * as React from "react";
import {Route, Redirect} from "react-router";
import {MainTemplate} from "../ui/view/MainTemplate";
import {ScheduledTournamentListView} from "../ui/view/poker/tournament/ScheduledTournamentListView";
import {UserListView} from "../ui/view/user/UserListView";
import {UserView} from "../ui/view/user/UserView";
import {UserGroupListView} from "../ui/view/user/UserGroupListView";
import {UserGroupView} from "../ui/view/user/UserGroupView";
import {WalletView} from "../ui/view/account/WalletView";
import {ScheduledTournamentView} from "../ui/view/poker/tournament/ScheduledTournamentView";
import {ItemListView} from "../ui/view/item/ItemListView";
import {ItemDetailView} from "../ui/view/item/ItemDetailView";
import {ItemPlayersListView} from "../ui/view/item/ItemPlayersListView";
import {ItemHistoryListView} from "../ui/view/item/ItemHistoryListView";
import {BonusConfigListView} from "../ui/view/bonus/BonusConfigListView";
import {BonusConfigView} from "../ui/view/bonus/BonusConfigView";
import {TriggersListView} from "../ui/view/achievements/TriggersListView";
import {TriggersConfigView} from "../ui/view/achievements/TriggersConfigView";
import {TriggersActivationView} from "../ui/view/achievements/TriggersActivationView";
import {HandHistoryListView} from "../ui/view/poker/history/HandHistoryListView";
import {HandView} from "../ui/view/poker/history/HandView";
import {TournamentHistoryListView} from "../ui/view/poker/history/TournamentHistoryListView";
import {HistoricTournamentView} from "../ui/view/poker/history/HistoricTournamentView";
import {SitAndGotListView} from "../ui/view/poker/tournament/SitAndGotListView";
import {SitAndGoView} from "../ui/view/poker/tournament/SitAndGoView";
import {BlindsStructureListView} from "../ui/view/poker/tournament/BlindsStructureListView";
import {BlindsStructureView} from "../ui/view/poker/tournament/BlindsStructureView";
import {PayoutStructureListView} from "../ui/view/poker/tournament/PayoutsStructureListView";
import {PayoutStructureView} from "../ui/view/poker/tournament/PayoutStructureView";
import {ProductListView} from "../ui/view/product/ProductListView";
import {ProductDetailView} from "../ui/view/product/ProductConfigView";
import {AccountsListView} from "../ui/view/account/AccountsListView";
import {MassUpdateView} from "../ui/view/account/MassUpdateView";
import {BlackjackHandHistoryListView} from "../ui/view/blackjack/history/BlackjackHandHistoryListView";
import {CaribbeanPokerHandHistoryListView} from '../ui/view/caribbean-poker/history/CaribbeanPokerHandHistoryListView'
import {CasinoHoldemHandHistoryListView} from '../ui/view/casino-holdem/history/CasinoHoldemHandHistoryListView'
import {ItemRefundView} from "../ui/view/item/ItemRefundView";
import {SlotSpinHistoryListView} from "../ui/view/slots/SlotSpinHistoryListView";


export const routes = (
    <Route component={MainTemplate} onChange={(prev, next) => {
        var nextRoutes = next.routes as any;
        if (nextRoutes && nextRoutes.length > 0 && nextRoutes[nextRoutes.length - 1]) {
            var path = nextRoutes[nextRoutes.length - 1].path;
            if (path == lastRoute) {
                lastRoute = path;
                return;
            } else {
                lastRoute = path;
            }

        }
        window.scrollTo(0, 0);
    }}>
        <Redirect from="/" to="/tournament-history" />
        <Route path="/tournaments" component={ScheduledTournamentListView}/>
        <Route path="/tournaments/**" component={ScheduledTournamentListView}/>
        <Route path="/tournament/:id(/:copyTemplate)" component={ScheduledTournamentView}/>
        <Route path="/tournament-structures/blinds" component={BlindsStructureListView}/>
        <Route path="/tournament-structures/blinds/**" component={BlindsStructureListView}/>
        <Route path="/tournament-structures/blind/:id(/:copyTemplate)" component={BlindsStructureView}/>

        <Route path="/tournament-structures/payouts" component={PayoutStructureListView}/>
        <Route path="/tournament-structures/payouts/**" component={PayoutStructureListView}/>
        <Route path="/tournament-structures/payout/:id(/:copyTemplate)" component={PayoutStructureView}/>

        <Route path="/sit-and-gos" component={SitAndGotListView}/>
        <Route path="/sit-and-gos/**" component={SitAndGotListView}/>
        <Route path="/sit-and-go/:id(/:copyTemplate)" component={SitAndGoView}/>

        <Route path="/users" component={UserListView}/>
        <Route path="/users/**" component={UserListView}/>
        <Route path="/user/:id" component={UserView}/>
        <Route path="/user-groups" component={UserGroupListView}/>
        <Route path="/user-group/:id" component={UserGroupView}/>
        <Route path="/accounts" component={AccountsListView}/>
        <Route path="/accounts/**" component={AccountsListView}/>
        <Route path="/mass-update-accounts" component={MassUpdateView}/>
        <Route path="/mass-update-accounts/**" component={MassUpdateView}/>
        <Route path="/wallet/:cubeiaId/:walletAccountCode" component={WalletView}/>

        <Route path="/bonus/:id" component={BonusConfigView}/>
        <Route path="/bonus/show/:id" component={BonusConfigView}/>
        <Route path="/bonus/show/:id/**" component={BonusConfigView}/>
        <Route path="/bonuses" component={BonusConfigListView}/>
        <Route path="/bonuses/**" component={BonusConfigListView}/>

        <Route path="/item" component={ItemListView}/>
        <Route path="/item/:id" component={ItemDetailView}/>
        <Route path="/item/:id/refund" component={ItemRefundView} />
        <Route path="/item/:id/players" component={ItemPlayersListView}/>
        <Route path="/item/:id/history" component={ItemHistoryListView}/>

        <Route path="/product" component={ProductListView}/>
        <Route path="/product/:id" component={ProductDetailView}/>

        <Route path="/trigger/activation" component={TriggersActivationView}/>
        <Route path="/triggers" component={TriggersListView}/>
        <Route path="/triggers/**" component={TriggersListView}/>

        <Route path="/trigger/:id" component={TriggersConfigView}/>
        <Route path="/trigger/:id/**" component={TriggersConfigView}/>
        <Route path="/trigger/show/:id" component={TriggersConfigView}/>
        <Route path="/trigger/show/:id/**" component={TriggersConfigView}/>

        <Route path="/hand-history" component={HandHistoryListView}/>
        <Route path="/hand-history/**" component={HandHistoryListView}/>
        <Route path="/hand/:id" component={HandView}/>

        <Route path="blackjack/hand-history" component={BlackjackHandHistoryListView}/>
        <Route path="blackjack/hand-history/**" component={BlackjackHandHistoryListView}/>

        <Route path="slots/admin-spin-history" component={SlotSpinHistoryListView}/>

        <Route path="caribbean-poker/hand-history" component={CaribbeanPokerHandHistoryListView}/>
        <Route path="caribbean-poker/hand-history/**" component={CaribbeanPokerHandHistoryListView}/>

        <Route path="casino-holdem/hand-history" component={CasinoHoldemHandHistoryListView}/>
        <Route path="casino-holdem/hand-history/**" component={CasinoHoldemHandHistoryListView}/>

        <Route path="/tournament-history" component={TournamentHistoryListView}/>
        <Route path="/tournament-history/**" component={TournamentHistoryListView}/>
        <Route path="/historic-tournament/:id" component={HistoricTournamentView}/>

    </Route>
);
let lastRoute = null;



// WEBPACK FOOTER //
// ./src/app/routing/Routes.tsx